export const MSG91_CONFIG = {
  authKey: process.env.REACT_APP_MSG91_AUTH_KEY,
  templateId: 'YOUR_TEMPLATE_ID',
  senderId: 'REDDYPS'
};

class SMSService {
  private isDevelopment = process.env.REACT_APP_ENV === 'development';

  async sendOTP(mobile: string): Promise<string> {
    if (this.isDevelopment) {
      console.log(`Development Mode - OTP for ${mobile}: 123456`);
      return 'local_verification_id';
    }

    try {
      const otp = this.generateOTP();
      const response = await fetch('https://api.msg91.com/api/v5/otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authkey': MSG91_CONFIG.authKey || ''
        },
        body: JSON.stringify({
          template_id: MSG91_CONFIG.templateId,
          mobile: mobile,
          authkey: MSG91_CONFIG.authKey,
          otp: otp,
          sender: MSG91_CONFIG.senderId
        })
      });

      const result = await response.json();
      
      if (result.type === 'success') {
        return result.request_id;
      } else {
        throw new Error(result.message || 'Failed to send OTP');
      }
    } catch (error) {
      console.error('SMS Send Error:', error);
      throw new Error('Failed to send OTP. Please try again.');
    }
  }

  async verifyOTP(verificationId: string, code: string): Promise<boolean> {
    if (this.isDevelopment) {
      return code === '123456';
    }

    try {
      const response = await fetch('https://api.msg91.com/api/v5/otp/verify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authkey': MSG91_CONFIG.authKey || ''
        },
        body: JSON.stringify({
          request_id: verificationId,
          otp: code
        })
      });

      const result = await response.json();
      return result.type === 'success';
    } catch (error) {
      console.error('OTP Verification Error:', error);
      return false;
    }
  }

  async resendOTP(mobile: string): Promise<string> {
    return this.sendOTP(mobile);
  }

  private generateOTP(): string {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }

  async sendCustomMessage(mobile: string, message: string): Promise<boolean> {
    if (this.isDevelopment) {
      console.log(`Development Mode - SMS to ${mobile}: ${message}`);
      return true;
    }

    try {
      const response = await fetch('https://api.msg91.com/api/sendhttp.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          authkey: MSG91_CONFIG.authKey || '',
          mobiles: mobile,
          message: message,
          sender: MSG91_CONFIG.senderId,
          route: '4'
        })
      });

      const result = await response.text();
      return result.includes('successfully');
    } catch (error) {
      console.error('Custom SMS Error:', error);
      return false;
    }
  }
}

export default new SMSService();